// Generated by scripts/gen_plans.py; edit services/plans.py or services/setup_registry.py, then regenerate.

export const PLAN_ORDER = {
  free: 0,
  club: 1,
  tour: 2,
} as const;

export const FEATURE_MIN_PLAN = {
  public_results: "free",
  tv_mode: "free",
  embed: "free",
  athlete_profiles: "free",
  timer: "free",
  counting: "free",
  rounds_manual: "free",
  criteria_sum4: "free",
  protests: "free",
  rounds_rules: "club",
  areas: "club",
  teams: "club",
  schedule: "club",
  criteria_custom: "club",
  trick_log: "club",
  sponsors: "club",
  fan_vote: "club",
  registration: "club",
  notifications_email: "club",
  pdf_printouts: "club",
  bibs_pdf: "club",
  rider_import: "club",
  clone: "club",
  templates: "club",
  announcer: "club",
  share_image: "club",
  athlete_accounts: "club",
  org_page_min: "club",
  checkin: "club",
  series_basic: "club",
  registration_paid: "club",
  custom_slug: "club",
  handoff_pack: "club",
  measured_entry: "club",
  combined_ranking: "club",
  notifications_push: "tour",
  notifications_sms: "tour",
  series_advanced: "tour",
  registration_zero_fee: "tour",
  white_label: "tour",
  api_keys: "tour",
  webhooks: "tour",
  organisations: "tour",
  memberships_lite: "tour",
} as const;

export const PASS_SCOPED = [
  "announcer",
  "areas",
  "bibs_pdf",
  "checkin",
  "clone",
  "combined_ranking",
  "criteria_custom",
  "custom_slug",
  "fan_vote",
  "handoff_pack",
  "measured_entry",
  "notifications_email",
  "pdf_printouts",
  "registration",
  "registration_paid",
  "rider_import",
  "rounds_rules",
  "schedule",
  "share_image",
  "sponsors",
  "teams",
  "trick_log",
] as const;

export const SHIPPED_MODULES = {
  public_results: true,
  tv_mode: true,
  embed: true,
  athlete_profiles: true,
  timer: true,
  counting: false,
  rounds_manual: false,
  rounds_rules: false,
  areas: false,
  teams: false,
  schedule: false,
  notifications_email: false,
  criteria_sum4: false,
  criteria_custom: false,
  trick_log: false,
  sponsors: true,
  fan_vote: false,
  protests: false,
  registration: false,
} as const;

export type FeatureKey = keyof typeof FEATURE_MIN_PLAN;
export type PlanKey = keyof typeof PLAN_ORDER;
